module.exports = __webpack_public_path__ + "static/media/sectorIndustrial.e6ffffc5.png";